module.exports = __webpack_public_path__ + "img/12-labours-logo-black.7405835e.png";